import React, { useContext, useLayoutEffect } from 'react';
import { CgMenu } from 'react-icons/cg';
import { useTranslation } from 'react-i18next';

import useWindowSize from 'hooks/useWindowSize';
import WindowSize from 'types/WindowSize';
import * as S from './styles';
import { color } from 'styles/pallete';
import { png } from 'utils/imgList';
import TitleNavBarContext from 'context/TitleNavBarContext';
import NavBarContext from 'context/NavBarContext';
import OptionsModal from 'components/OptionsModal';
import { UseTranslationProps } from 'types/UseTranslationProps';

export default function NavTitleBar() {
	const { t }: UseTranslationProps = useTranslation();
	const { width }: WindowSize = useWindowSize();
	const { dataAbouTitle } = useContext(TitleNavBarContext);
	const { setIsOpen } = useContext(NavBarContext);

	useLayoutEffect(() => {
		if (width !== undefined && width > 1000) {
			setIsOpen(true);
		}
	}, [width]);

	return (
		<S.container>
			{width! > 1000 && (
				<S.title>
					<p>{t(dataAbouTitle.title || 'Mondelez Error')}</p>
					{dataAbouTitle.subtitle !== '' && (
						<label>{t(dataAbouTitle.subtitle)}</label>
					)}
				</S.title>
			)}

			{width! <= 1000 && (
				<S.logoWithMenu>
					<CgMenu
						onClick={() => {
							setIsOpen((value) => !value);
						}}
						style={{
							color: color.interface.darkgray3,
							fontSize: '20px',
							cursor: 'pointer'
						}}
					/>
					<img src={png.logoMarcaPreta} alt="logo marca preta" />
				</S.logoWithMenu>
			)}
			<S.options>
				<S.optionsModal>
					<OptionsModal />
				</S.optionsModal>
			</S.options>
		</S.container>
	);
}
